import _ from 'lodash';

const initialState = {
  document: {},
  showModal: false,
  showConfirmModal: false,
  updatedName: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'RENAME_MODAL_TOGGLE_MODAL_DISPLAY': {
      return {
        ...state,
        showModal: action.showModal,
      };
    }

    case 'RENAME_MODAL_TOGGLE_CONFIRM_MODAL_DISPLAY': {
      return {
        ...state,
        showConfirmModal: action.showConfirmModal,
      };
    }

    case 'RENAME_MODAL_SET_DOCUMENT': {
      return {
        ...state,
        document: action.document,
      };
    }

    case 'RENAME_MODAL_SET_UPDATED_NAME': {
      return {
        ...state,
        updatedName: action.updatedName,
      };
    }

    case 'RENAME_MODAL_RESET':
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
